<template>
  <div v-loading="loading" class="wrap">
    <!-- 加载 -->
    <div class="loading">
      <div class="text">正在加载...</div>
      <div class="progress">
        <div class="wrap">
          <div
            class="full"
            :style="{width: Math.floor(imgLoadedTotal/preloaderImgPaths.length * 100) + '%'}"
          ></div>
        </div>
        <span>{{ Math.floor(imgLoadedTotal/preloaderImgPaths.length * 100) + '%' }}</span>
      </div>
    </div>

    <!-- mac -->
    <div v-if="macInputVisible" class="mac">
      <div class="mac-container">
        <div class="env-box">
          <div
            v-for="item in cloudList"
            :key="item.code"
            class="env-item"
            :class="{ active: envCode === item.code }"
            @click="selEnv(item.code)"
          >{{ item.name }}</div>
        </div>
        <div class="mac-title">请填写设备MAC地址以作校验识别</div>
        <input v-model="mac" class="mac-input" type="text" />
        <!-- <el-switch
          v-model="terminal"
          class="mac-terminal"
          style="display: block"
          inactive-color="#13ce66"
          active-text="支付宝"
          inactive-text="微信"
          @change="change"
        ></el-switch> -->
        <div class="mac-btn" @click="getDeviInfo">确定</div>
      </div>
    </div>
    <!-- retry -->
    <div v-if="retryVisible" class="retry">
      <div class="retry-container">
        <div class="retry-title">未配置该MAC地址，请联系管理员配置后重试</div>
        <div class="retry-btn">重试</div>
      </div>
    </div>
    <div v-if="showReset" class="retry">
      <div class="retry-container">
        <div class="retry-title">请求获取环境列表失败，请检查设备网络。</div>
        <div class="retry-btn" @click="reset">重试</div>
      </div>
    </div>
  </div>
</template>

<script>
let vConsole = null
import axios from 'axios';
import { mapMutations } from 'vuex';
import Cookies from 'js-cookie';
import { getLocalStorage, setLocalStorage } from '@/utils/auth';
export default {
  components: {

  },
  props: {

  },
  data () {
    return {
      envCode: '0',
      preloaderImgPaths: [], // 预加载的图片路径数组
      imgLoadedTotal: 0, // 已经加载完成的图片总数
      macInputVisible: false, //
      mac: '', // mac
      retryVisible: false,
      loading: false,
      terminal: false,
      sendReqbol: true,
      cloudList: [],
      showReset: false
    };
  },
  computed: {
    // appid
    appid () {
      return this.$store.state.app.appid;
    },
    // 大屏配置信息
    baseSettingInfo: {
      get () { return this.$store.state.app.baseSettingInfo; },
      set (val) { this.$store.commit('app/set_baseSettingInfo', val); }
    },
    // 设备信息
    deviInfo: {
      get () { return this.$store.state.app.deviInfo; },
      set (val) { this.$store.commit('app/set_deviInfo', val); }
    },
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    },
    // 设备信息
    qrcodeUrl: {
      get () { return this.$store.state.app.qrcodeUrl; },
      set (val) { this.$store.commit('app/set_qrcodeUrl', val); }
    },
    // poi分类列表
    poiCategroyList: {
      get () { return this.$store.state.nav.poiCategroyList; },
      set (val) { this.$store.commit('nav/set_poiCategroyList', val); }
    },
    // 所有建筑节点
    allNodeList: {
      get () { return this.$store.state.nav.allNodeList; },
      set (val) { this.$store.commit('nav/set_allNodeList', val); }
    },
    // 所有POI列表
    allPoiList: {
      get () { return this.$store.state.nav.allPoiList; },
      set (val) { this.$store.commit('nav/set_allPoiList', val); }
    },
    // 百度token
    baiduToken: {
      get () { return this.$store.state.app.baiduToken; },
      set (val) { this.$store.commit('app/set_baiduToken', val); }
    },
    // 当前地图所有节点的集合，键值对形式（以ID为键值）
    allNodeObjById () {
      return this.$store.getters['nav/allNodeObjById'];
    }
  },
  watch: {

  },
  async created () {
    this.reset();
  },
  mounted () {
  },
  methods: {
    async reset () {
      let url_Code = this.$route.query.envCode;
      let cookie_envCode = Cookies.get('envCode') || getLocalStorage('envCode');
      // let terminal = Cookies.get('terminal') || getLocalStorage('terminal');
      let envCode = url_Code || cookie_envCode;
      // this.terminal = terminal === 'true';
      axios
        .post('/proxy/api/cust/cloud/list', {})
        .then((res) => {
          if (res.data.code === 0 && res.data.data) {
            this.showReset = false;
            console.log('getCloudList', res);
            this.cloudList = JSON.parse(res.data.data);
            this.envCode = envCode || this.cloudList[0].code;
            setLocalStorage('envCode', this.envCode);
            let envJson = {};
            this.cloudList.forEach(item => {
              envJson[item.code] = item;
            });
            setLocalStorage('envJson', JSON.stringify(envJson));
            if (this.cloudList.length === 1) {
              this.selEnv(this.cloudList[0].code);
            }
          } else {
            this.$message.error(res.data ? res.data.msg : '请求错误');
            this.showReset = true;
          }
          this.getData();
        })
        .catch((error) => {
          this.$message.error('请求获取环境列表失败');
          this.showReset = true;
          console.log(error);
        });
    },
    async getData () {
      await this.preloaderImg();
      console.log(this.$route);
      let url_mac = this.$route.query.mac;
      let cookie_mac = Cookies.get('mac');

      // 如果url参数带mac
      if (url_mac) {
      // 获取设备信息
        this.loading = true;
        let screenInfo = await this.getScreenInfo(url_mac);
        this.loading = false;
        if (screenInfo) {
          this.deviInfo = screenInfo;
          this.mac = url_mac;
          Cookies.set('mac', url_mac, { expires: 30 });
          this.init();
        } else {
          this.macInputVisible = true;
          this.$message.error('未配置该MAC地址，请联系管理员配置后重试');
        }
      // 否则查看cookie是否有mac
      } else if (cookie_mac) {
        let screenInfo = await this.getScreenInfo(cookie_mac);
        if (screenInfo) {
          this.deviInfo = screenInfo;
          this.mac = cookie_mac;
          Cookies.set('mac', cookie_mac, { expires: 30 });
          this.init();
        } else {
          this.macInputVisible = true;
          this.$message.error('未配置该MAC地址，请联系管理员配置后重试');
        }
      // 以上都无，则手动输入mac
      } else {
        this.macInputVisible = true;
      }
      this.envNum = localStorage.getItem('envNum') ? Number(localStorage.getItem('envNum')) : 1;
    },
    ...mapMutations('app', [
      // 设置地图参数
      'set_appid'
    ]),
    change () {
      setLocalStorage('terminal', this.terminal);
    },
    selEnv (envCode) {
      this.envCode = envCode;
      setLocalStorage('envCode', envCode);
      // location.reload();
    },
    // 预加载图片
    preloaderImg () {
      return new Promise((resolve, reject) => {
        // 获取图片所有需要预加载的图片路径
        const files = require.context('@/../public/images/preloader', true);
        files.keys().forEach(key => {
          this.preloaderImgPaths.push('/images/preloader/' + key.replace(/.\//, ''));
        });
        console.log('preloaderImgPaths', this.preloaderImgPaths);
        // 加载图片
        this.preloaderImgPaths.forEach(item => {
          let img = new Image();
          img.src = item;
          img.onload = () => {
            this.imgLoadedTotal++;
            if (this.imgLoadedTotal === this.preloaderImgPaths.length) {
              resolve();
            }
          };
          img.onerror = () => {
            reject();
          };
        });
        if (this.preloaderImgPaths.length === 0) {
          resolve();
        }
      });
    },
    // 初始化
    async init () {
      // 获取建筑信息
      let buildInfo = await this.getBuildDetail(this.deviInfo.buildId);
      console.log('buildInfo', buildInfo);
      this.buildInfo = buildInfo;
      const IS_DEV = process.env.VUE_APP_ENV === 'dev';
      let appId = IS_DEV ? (buildInfo.buildType === '1' ? 'wx92906fee5cb09f1a' : 'wx4c44420601d3df26') : buildInfo.buildType === '1' ? 'wx1d5dbdc2760788da' : 'wx04d01b151a28a60b';
      this.set_appid(appId);
      if (this.terminal) {
        IS_DEV ? this.set_appid('2021004101653172') : this.set_appid('2021004101644322');
      }
      // this.buildInfo = {
      //   buildId: '1192358133675192321'
      // };

      // 获取二维码
      // let params = this.$utils.urlEncode({ b: this.buildInfo.buildId, e: this.envCode }, false);
      // let res = await this.getAppQrcode(this.appid, params);
      // this.qrcodeUrl = res;
      // 获取地图数据
      let poiList = await this.getPoiTopList(this.buildInfo.buildId);
      this.poiCategroyList = poiList;
      // 获取建筑节点
      let allNodeList = await this.queryAllNode(this.buildInfo.buildId);
      this.allNodeList = allNodeList;
      // 获取POI列表
      let allPoiList = await this.queryAllPoiList(this.buildInfo.buildId);
      this.allPoiList = allPoiList;
      // 获取大屏基本信息
      let baseSettingInfo = await this.getBaseSettingInfo(this.buildInfo.buildId);
      this.baseSettingInfo = baseSettingInfo;
      // 获百度token
      let baiduToken = await this.getBaiduToken();
      this.baiduToken = baiduToken;
      // 跳转到大屏首页
      setTimeout(() => { this.$router.push({ path: '/index' }); }, 500);
    },
    // 获取设备信息
    async getDeviInfo () {
      if (this.mac === '调试模式') {
        if (vConsole) {
          vConsole.destroy();
        } else {
          vConsole = new window.VConsole();
        }
        return;
      }
      if (this.mac.replace(/\s+/g, '') === '') { return; }
      if (!this.sendReqbol) { return; }
      this.sendReqbol = false;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        let screenInfo = await this.getScreenInfo(this.mac);
        if (screenInfo) {
          this.deviInfo = screenInfo;
          Cookies.set('mac', this.mac, { expires: 30 });
          await this.init();
          android.cacheMac(this.mac);
          android.saveCacheEnvCode(this.envCode);
        } else {
          // this.retryVisible = true;
          this.$message.error('未配置该MAC地址，请联系管理员配置后重试');
        }
      } catch (error) {
        loading.close();
        console.error(error);
      }
      loading.close();
      setTimeout(() => {
        this.sendReqbol = true;
      }, 1000);
    },
    // 获取设备信息
    async getScreenInfo (mac = null) {
      try {
        let res = await this.$apis.app.getScreenInfo({ mac });
        let data = res.data ? JSON.parse(res.data) : false;
        console.log('设备信息：', data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    // 获取建筑信息
    async getBuildDetail (buildId) {
      try {
        let res = await this.$apis.nav.getBuildDetail({ buildId });
        let data = JSON.parse(res.data);
        console.log('建筑信息：', data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    // 获取二维码
    async getAppQrcode (appid, params, page = 'pages/index/index', width = 400) {
      let options = {};
      if (this.terminal) {
        options = {
          headers: {
            'source-type': 'ali'
          }
        };
      }
      try {
        let res = await this.$apis.app.getAppQrcode({
          page: page, // 跳转的页面，可空，不传默认pages/index/index
          width: width, // 二维码宽度，可空，不传默认500
          scene: params, // 自定义参数，微信将追加至后面
          appId: appid
        }, options);
        let parseData = 'data:image/jpeg;base64,' + (res.data).replace(/"/g, '');
        return parseData;
      } catch (error) {
        console.error(error);
      }
    },
    // 获取POI顶部列表（带图标）
    async getPoiTopList (buildId) {
      try {
        let data = await this.$apis.nav.poiTopList({ buildId });
        let parseData = JSON.parse(data.data);
        console.log('poi列表：', parseData);
        return parseData;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    // 查询所有节点
    async queryAllNode (buildId, limit = 500) {
      try {
        let arr = [];
        let totalPage = 0;
        let currPage = 0;
        do {
          currPage++;
          let data = await this.$apis.nav.queryNode({ buildId, page: currPage, limit });
          if (data.data) {
            let res = JSON.parse(data.data);
            totalPage = res.totalPage;
            arr.push(...res.list);
          }
        }
        while (currPage < totalPage);
        console.log('建筑所有节点:', arr);
        return arr;
      } catch (error) {
        console.error('查询所有节点报错信息', error);
      }
    },
    // 查询所有poi列表
    async queryAllPoiList (buildId, floor = null, searchValue = null) {
      try {
        let res = await this.$apis.nav.queryAllPoiList({ buildId, floor, searchValue });
        let data = JSON.parse(res.data);
        let arr = [];
        console.log('this.allNodeObjById', this.allNodeObjById);
        data.forEach(item => {
          // 如果该POI有对应的节点
          if (this.allNodeObjById.hasOwnProperty(item.beaconId)) {
            let node = this.allNodeObjById[item.beaconId];
            let obj = {
              id: item.beaconId,
              poiId: item.itemId,
              name: item.itemName,
              itemRemark: item.itemRemark,
              images: item.images,
              buildId: item.buildId,
              x: node.x,
              y: node.y,
              floor: parseInt(node.floor),
              showFloor: this.buildInfo.floorNameList ? this.buildInfo.floorNameList[node.floor - 1] : node.floor
            };
            arr.push(obj);
          }
        });
        console.log('所有poi列表:', arr);
        return arr;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    // 获取百度token
    async getBaiduToken () {
      try {
        let data = await this.$apis.app.getBaiduToken();
        data = JSON.parse(data.data);
        return data.access_token;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    // 获取app配置信息
    async getBaseSettingInfo (buildId) {
      if (!buildId) {
        return {};
      }
      try {
        let res = await this.$apis.app.getBaseSettingInfo({ buildId });
        let data = res.data;
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    }
  }
};
</script>

<style scoped lang="scss">
.wrap {
  height: 100%;
  width: 100%;
  background: url('/images/preloader/bg-main.jpg') center center no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}

.loading {
  flex: 1;
  margin: -100px 0 0 0;
  .text {
    color: $color-white;
    margin: 0 0 20px 0;
    font-size: 36px;
  }
}
.progress {
  display: flex;
  justify-content: center;
  align-items: center;
  .wrap {
    width: 40%;
    height: 20px;
    border-radius: 20px;
    overflow: hidden;
    background: #508aa1;
    .full {
      height: 100%;
      border-radius: 20px;
      background: linear-gradient(to bottom, #38e8a9 0%, #03af6c 100%);
    }
  }
  span {
    color: $color-white;
    margin: 0 0 0 20px;
    font-size: 30px;
  }
}
.mac {
  position: fixed;
  top: 0;
  left: 0;
  background: $color-opacity-regular;
  width: 100%;
  height: 100%;
  &-container {
    width: 788px;
    height: 463px;
    background: url('/images/preloader/rect4.png') no-repeat;
    background-size: 100% 100%;
    padding: 36px 9px 14px 9px;
    box-sizing: border-box;
    color: $color-white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  &-title {
    font-size: 26px;
  }
  &-input {
    border: 1px solid #618aaf;
    border-radius: 10px;
    width: 400px;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
    text-align: left;
    color: $color-white;
    font-size: 26px;
    padding: 0 20px;
    margin: 40px 0 60px 0;
    box-sizing: border-box;
    background: transparent;
    &:focus {
      outline: none;
      // border: none;
    }
    &::-webkit-input-placeholder {
      color: #ccc;
    }
  }
  .mac-terminal {
    margin-bottom: 40px;
    ::v-deep .el-switch__label *{
      color: $color-white;
      font-size: 24px !important;
    }
  }
  &-btn {
    width: 180px;
    height: 60px;
    margin: 0 auto;
    box-shadow: 0 0 10px $color-opacity-primary;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    border-radius: 50px;
    background: linear-gradient(to bottom, #40e9ad 0%, #03af6c 100%);
  }
}
.retry {
  position: fixed;
  top: 0;
  left: 0;
  background: $color-opacity-regular;
  width: 100%;
  height: 100%;
  &-container {
    width: 788px;
    height: 417px;
    background: url('/images/preloader/rect4.png') no-repeat;
    padding: 85px 9px 14px 9px;
    background-size: 100% 100%;
    box-sizing: border-box;
    color: $color-white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  &-title {
    font-size: 26px;
  }
  &-btn {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 70px;
    margin: auto;
    width: 180px;
    height: 60px;
    margin: 0 auto;
    box-shadow: 0 0 10px $color-opacity-primary;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    border-radius: 50px;
    background: linear-gradient(to bottom, #40e9ad 0%, #03af6c 100%);
  }
}
.env-box {
  display: flex;
  width: 400px;
  height: 50px;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #ffffff;
  margin: 0 auto 40px;
  .env-item {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 500;
    border-bottom: 2px solid rgba(0, 0, 0, 0);
    cursor: pointer;
  }
  .active {
    color: #00cd96;
    border-bottom: 2px solid #00cd96;
  }
}
</style>
